export interface MarginSetupSlice {
    contractStartDate: Date;
    contractEndDate: Date;
    days: number;
    hoursPerShift: number;
    readonly totalHours: number;
    billRate: number;
    payRate: number;
    overtimeBillRate: number;
    overtimePayRate: number;
    overtimeRateFactor: number;
    holidayBillRate: number;
    holidayPayRate: number;
    holidayRateFactor: number;
}

export const initialMarginSetupSlice: MarginSetupSlice = {
    contractStartDate: new Date(),
    contractEndDate: new Date(),
    days: 0,
    hoursPerShift: 0,
    totalHours: 0,
    billRate: 0,
    payRate: 0,
    overtimeBillRate: 0,
    overtimePayRate: 0,
    overtimeRateFactor: 0,
    holidayBillRate: 0,
    holidayPayRate: 0,
    holidayRateFactor: 0
};
